import Vue from 'vue'
import VueRouter from 'vue-router'

import PlaylistListingPage from './pages/PlaylistListingPage.vue'
import PlaylistCreationPage from './pages/PlaylistCreationPage.vue'
import NotFound from './pages/NotFound.vue'


Vue.use(VueRouter);
const router=new VueRouter({
    mode:'history',
    routes:[
        { path:'/', redirect:'/playlists'},
        { path:'/playlists', component : PlaylistListingPage},
        { path:'/playlists/addPlaylist', component : PlaylistCreationPage },  
       
        { path:'/:NotFound(.*)', component : NotFound },
        
    ],

});
export default router;